exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".small-button {\n    font-size: 0.7em;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/orders/search/confirmation-modal/confirmation-modal.component.css
// module id = ../../../../../src/app/orders/search/confirmation-modal/confirmation-modal.component.css
// module chunks = main